import fetch from "lib/fetch";

export interface AdCategoryReference {
    value: string;
    subcategories: Array<{ value: string }>;
}

export type AdCategoryReferenceResponse = Array<AdCategoryReference> | { data: Array<AdCategoryReference> };

export const getAdCategoriesRequest = () => fetch.get<AdCategoryReferenceResponse>("reference/ad_category");
